/**
 * Centralized API routes for the wellness admin application.
 * Use these constants instead of hardcoded strings throughout the codebase.
 */

// API Routes - relative paths (baseURL is set in axios instance)
export const API_ROUTES = {
  // Authentication
  AUTH: {
    LOGIN: "/auth/admin/login",
    REFRESH: "/auth/refresh",
    LOGOUT: "/auth/logout",
  },

  // Users
  USERS: {
    BASE: "/users/",
    BY_ID: (id: number) => `/users/${id}`,
  },

  // Categories
  CATEGORIES: {
    BASE: "/categories/",
    BY_ID: (id: number) => `/categories/${id}/`,
  },

  // Products
  PRODUCTS: {
    BASE: "/products/",
    BY_ID: (id: number) => `/products/${id}/`,
  },

  // Feeds
  FEEDS: {
    BASE: "/feeds/",
    BY_ID: (id: number) => `/feeds/${id}`,
    CATEGORIES: "/feeds/categories",
  },

  // Notifications
  NOTIFICATIONS: {
    BASE: "/notifications/",
    BY_ID: (id: number) => `/notifications/${id}`,
    BROADCAST: "/notifications/broadcast",
  },

  // DXN Directory
  DIRECTORY: {
    BASE: "/dxn-directory/",
    BY_ID: (id: number) => `/dxn-directory/${id}`,
  },

  // Daily Facts
  FACTS: {
    BASE: "/facts/",
    BY_ID: (id: number) => `/facts/${id}`,
    BY_TYPE: (type: string) => `/facts/type/${type}`,
    BULK_UPLOAD: "/facts/bulk-upload",
  },

  // Challenges
  CHALLENGES: {
    BASE: "/challenges/",
    BY_ID: (id: number) => `/challenges/${id}`,
    BY_TYPE: (type: string) => `/challenges/type/${type}`,
  },

  // Wellness Activities
  WELLNESS: {
    BASE: "/wellness/",
    BY_ID: (id: number) => `/wellness/${id}/`,
    BY_TYPE: (type: string) => `/wellness/type/${type}`,
  },

  // Dashboard
  DASHBOARD: {
    STATS: "/dashboard/stats",
  },

  // Cards
  CARDS: {
    BASE: "/cards/",
    ALL: "/cards/content",
    BY_ID: (id: number) => `/cards/${id}`,
    BY_TYPE: "/cards/",
    TYPES: {
      BASE: "/cards/types",
      BY_ID: (id: number) => `/cards/types/${id}`,
    },
  },

  // Support Tickets (Admin)
  SUPPORT: {
    TICKETS: "/support/admin/tickets",
    REPLY: (ticketId: number) => `/support/admin/tickets/${ticketId}/reply`,
  },

  // Influencer Submissions (Admin)
  INFLUENCER: {
    BASE: "/admin/influencer/submissions",
    BY_ID: (id: number) => `/admin/influencer/submissions/${id}`,
    APPROVE: (id: number) => `/admin/influencer/submissions/${id}/approve`,
    REJECT: (id: number) => `/admin/influencer/submissions/${id}/reject`,
    EDIT: (id: number) => `/admin/influencer/submissions/${id}/edit`,
  },
} as const;

// Legacy export for backward compatibility
const base_url = import.meta.env.VITE_PROD_API_URL;
export const apiRoutes = {
  categories: base_url + "/categories/",
  products: base_url + "/products/",
  directories: base_url + "/dxn-directory/",
};

export default API_ROUTES;
